import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { Calendar, X } from "react-feather";
import Modal from "react-modal";
import { createGlobalStyle } from "styled-components";
import { IPrefeitura, usePrefeitura } from "../../Hooks/usePrefeitura";
import theme from "../../Styles/theme";
import { ModalDivX } from "../ModalDivX";
import { MunicipioSelector } from "../MunicipioSelector";
import { IFiltroImovel, useImovel } from "../../Hooks/imoveis";

import {
  Button,
  Container,
  DateSelectorContainer,
  DivButtons,
  Input,
  Label,
  LabelDate,
  Title,
} from "./styles";
import { useFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";

interface Props {
  open: boolean;
  onClose(): void;
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

const DatePickerWrapperStyles = createGlobalStyle`
  .formata-date-picker {
      background-color: ${theme.colors.light};
      border:none;
      border-radius:0.25rem;
      color:${theme.colors.dark};
     font-size: max(0.8vw , 8px);
   
  }
`;

export function FiltroImovelModal({ open, onClose }: Props) {
  const [municipioFocus, setMunicipioFocus] = useState({} as IPrefeitura);
  const [localizacao, setLocalizacao] = useState("");
  const [transmitente, setTransmitente] = useState("");
  const [adquirinte, setAdquirinte] = useState("");
  const [dataCriacao, setDataCriacao] = useState(null as Date | null);
  const [dataEnvio, setdataEnvio] = useState(null as Date | null);
  const [dataAvaliacao, setDataAvaliacao] = useState(null as Date | null);
  const { filtro, handleSetFiltro } = useImovel();
  const { prefeituraIsLogged, prefeitura } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  useEffect(() => {}, [open]);

  function resetForm() {
    setMunicipioFocus({} as IPrefeitura);
    setLocalizacao("");
    setTransmitente("");
    setAdquirinte("");
    setDataCriacao(null);
    setdataEnvio(null);
    setDataAvaliacao(null);
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <DatePickerWrapperStyles />

        <Title>Filtrar Imóveis</Title>
        {prefeituraIsLogged || funcionarioPrefeituraIsLogged ? (
          ""
        ) : (
          <MunicipioSelector
            execute={(pref: IPrefeitura) => {
              setMunicipioFocus(pref);
            }}
            initialValue={filtro.prefeitura_id ? filtro.prefeitura_id : 0}
          />
        )}

        <Label>
          Localização
          <Input
            value={localizacao}
            onChange={(ev) => setLocalizacao(ev.target.value)}
          />
        </Label>
        <Label>
          Transmitente
          <Input
            value={transmitente}
            onChange={(ev) => setTransmitente(ev.target.value)}
          />
        </Label>
        <Label>
          Adquirinte
          <Input
            value={adquirinte}
            onChange={(ev) => setAdquirinte(ev.target.value)}
          />
        </Label>

        <DateSelectorContainer>
          <LabelDate style={{}}>
            Data máxima de Envio
            <DatePicker
              // minDate={new Date()}
              value={dataEnvio}
              onChange={setdataEnvio}
              locale="pt-br"
              format="dd/MM/yyyy"
              className="formata-date-picker"
              calendarIcon={
                <Calendar
                  size={"calc(0.4vw + 8px)"}
                  color={theme.colors.dark}
                />
              }
              clearIcon={
                <X size={"calc(0.6vw + 8px)"} color={theme.colors.dark} />
              }
            />
          </LabelDate>

          <LabelDate style={{}}>
            Data máxima de Avaliação
            <DatePicker
              // minDate={new Date()}
              value={dataAvaliacao}
              onChange={setDataAvaliacao}
              locale="pt-br"
              format="dd/MM/yyyy"
              className="formata-date-picker"
              calendarIcon={
                <Calendar
                  size={"calc(0.4vw + 8px)"}
                  color={theme.colors.dark}
                />
              }
              clearIcon={
                <X size={"calc(0.6vw + 8px)"} color={theme.colors.dark} />
              }
            />
          </LabelDate>
        </DateSelectorContainer>
        <DivButtons>
          <Button
            onClick={() => {
              handleSetFiltro({
                adquirinte: adquirinte,
                ativo: true,
                data_avaliacao: dataAvaliacao,
                data_criacao: dataCriacao,
                localizacao: localizacao,
                data_envio: dataEnvio,
                prefeitura_id:
                  prefeituraIsLogged || funcionarioPrefeituraIsLogged
                    ? prefeitura.ID
                    : municipioFocus.ID,
                transmitente: transmitente,
              });
              onClose();
            }}
          >
            Filtrar
          </Button>
          <Button
            onClick={() => {
              handleSetFiltro({} as IFiltroImovel);
              resetForm();
              onClose();
            }}
          >
            Cancelar Filtro
          </Button>
        </DivButtons>
      </Container>
    </Modal>
  );
}
